import _objectSpread from "/data/repos/372_20260903142405/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import { showToast } from 'vant';
import Clipboard from 'clipboard';
import iconWechat from '@/assets/images/icon_wechat@2x.png';
import iconWechatMoments from '@/assets/images/icon_pengyou@2x.png';
import iconWeibo from '@/assets/images/icon_weibo@2x.png';
import iconQQ from '@/assets/images/icon_qq@2x.png';
import iconDingtalk from '@/assets/images/icon_dingtalk@2x.png';
import iconMofun from '@/assets/images/icon_mofun@2x.png';
import iconLetter from '@/assets/images/icon_letter@2x.png';
import iconLink from '@/assets/images/icon_link@2x.png';
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    shareOptions: {
      type: Object,
      default: function _default() {}
    },
    success: {
      type: Function,
      default: function _default() {}
    },
    fail: {
      type: Function,
      default: function _default() {}
    }
  },
  components: {},
  data: function data() {
    return {
      visible: false,
      title: '分享到',
      innerShareOptions: {
        // apiList: ['Wechat', 'WechatMoments', 'SinaWeibo', 'QQ', 'DingTalk', 'Mofun', 'Letter', 'CopyUrl'],
        apiList: ['Wechat', 'WechatMoments', 'SinaWeibo', 'QQ', 'DingTalk', 'Mofun', 'CopyUrl'],
        title: '',
        titleUrl: '',
        text: '',
        url: '',
        shareType: '',
        success: function success() {},
        fail: function fail() {},
        complete: function complete() {}
      }
    };
  },
  emits: ['update:modelValue'],
  computed: {
    apiDatas: function apiDatas() {
      return {
        Wechat: {
          icon: iconWechat,
          label: ' 微信 '
        },
        WechatMoments: {
          icon: iconWechatMoments,
          label: ' 朋友圈 '
        },
        SinaWeibo: {
          icon: iconWeibo,
          label: ' 新浪 '
        },
        QQ: {
          icon: iconQQ,
          label: ' QQ '
        },
        DingTalk: {
          icon: iconDingtalk,
          label: ' 钉钉 '
        },
        Mofun: {
          icon: iconMofun,
          label: ' 摩范圈 '
        },
        Letter: {
          icon: iconLetter,
          label: ' 私信和群 '
        },
        CopyUrl: {
          icon: iconLink,
          label: ' 链接 '
        }
      };
    },
    apiList: function apiList() {
      var _this = this;
      return this.innerShareOptions.apiList.map(function (item) {
        return {
          name: item,
          label: _this.apiDatas[item].label,
          icon: _this.apiDatas[item].icon,
          id: Math.random()
        };
      });
    }
  },
  methods: {
    setOptions: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var apiList = this.innerShareOptions.apiList;
      this.innerShareOptions = _objectSpread(_objectSpread(_objectSpread({}, this.innerShareOptions), JSON.parse(JSON.stringify(options))), {}, {
        success: options.success || this.success,
        fail: options.fail || this.fail
      });
      this.innerShareOptions.apiList = this.innerShareOptions.apiList.length ? this.innerShareOptions.apiList : apiList;
    },
    open: function open() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.setOptions(options);
      this.visible = true;
      this.copyUrl();
    },
    hide: function hide() {
      this.visible = false;
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    copyUrl: function copyUrl() {
      var _this2 = this;
      var titleUrl = this.innerShareOptions.titleUrl;
      this.$nextTick(function () {
        var clipboard = new Clipboard('.btn-copy-link', {
          // 绑定需要的触发的dom
          text: function text() {
            return titleUrl;
          }
        });
        clipboard.on('success', function (e) {
          _this2.innerShareOptions.complete && _this2.innerShareOptions.complete(e);
          _this2.innerShareOptions.success && _this2.innerShareOptions.success(e);
          _this2.visible = false;
          showToast('已复制');
        });
        clipboard.on('error', function (e) {
          _this2.innerShareOptions.complete && _this2.innerShareOptions.complete(e);
          _this2.innerShareOptions.error && _this2.innerShareOptions.error(e);
        });
      });
    },
    openAppShare: function openAppShare(item, index) {
      console.log('我点击了' + item.name);
      console.log(window.android);
      var success = this.innerShareOptions.success;
      // if (item.name === 'CopyUrl') {
      //   return;
      // }
      if (success) {
        success(_objectSpread(_objectSpread({}, item), {}, {
          index: index
        }));
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {
    modelValue: function modelValue(newValue) {
      var _this3 = this;
      this.$nextTick(function () {
        if (newValue) {
          _this3.setOptions(_this3.shareOptions);
          _this3.copyUrl();
        }
        _this3.visible = newValue;
      });
    },
    visible: function visible(newValue) {
      this.$emit('update:modelValue', newValue);
    }
  }
};